// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export const ScopeTypes = {
    TEAM: 'team',
    CHANNEL: 'channel',
};
